const clamp = (val: number, min: number, max: number): number => Math.max(min, Math.min(val, max))

export default clamp
